<template>
<div class="channel-bar" :class="channelClass">
    <div class="channel" :class="channel">{{ channel }}</div>
    <!-- <i class="fa fa-cog"></i> -->
</div>

</template>

<script>
export default {
    name: 'channelBar',
    computed: {
        channel() {
            let channel = this.$store.state.channel

            if (channel == 'main') { return '3ABN'}
            if (channel == 'proc') { return 'Proclaim'}
            if (channel == 'dare') { return 'Dare To Dream'}
            if (channel == 'int') { return '3ABN International'}
            if (channel == 'kids') { return '3ABN Kids Network'}
            if (channel == 'lat') { return '3ABN Latino'}
            if (channel == 'radio') { return '3ABN Radio'}
            return '#ABN'
        },
        channelClass() {
            return this.$store.state.channel
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/channel-bar.vue